export enum Field {
	BrowserExtension = 'browserExtension',
	DisplayName = 'memberDisplayName',
	Role = 'role',
	TwoFactor = 'twoFactorAuthentication',
}
